window.PushActions = {
  handlePushNotification(jsonString) {
    if (window.vueRoot) {
      const notification = JSON.parse(jsonString)
      window.vueRoot.$emit('push-notification-received', notification)
    }
  }
}
